import React, { useState } from 'react';
import ContactHero from '../components/ContactHero';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    smsConsent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // 1. Send email using Web3Forms (free, no signup)
      try {
        const response = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            access_key: '299fa7db-e0e1-4bc3-ae4c-ef0b91054c52',
            subject: `New Contact from ${formData.firstName} ${formData.lastName}`,
            from_name: `${formData.firstName} ${formData.lastName}`,
            email: formData.email,
            to_email: 'ahmadyasin7786@gmail.com',
            message: `
CUSTOMER DETAILS:
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}

MESSAGE DETAILS:
Subject: ${formData.subject}
Message: ${formData.message}

SMS CONSENT: ${formData.smsConsent ? 'Yes' : 'No'}

Submitted: ${new Date().toLocaleString()}
            `
          })
        });

        const result = await response.json();
        if (result.success) {
          console.log('✅ Email sent successfully to ahmadyasin7786@gmail.com');
        } else {
          console.error('❌ Email failed:', result.message);
        }
      } catch (emailError) {
        console.error('❌ Email error:', emailError);
      }

      // 2. Send to WhatsApp
      let message = `📋 *NEW CONTACT FORM SUBMISSION* 📋\n\n`;
      message += `👤 *Customer Details*\n`;
      message += `Name: ${formData.firstName} ${formData.lastName}\n`;
      message += `Email: ${formData.email}\n`;
      message += `Phone: ${formData.phone}\n\n`;
      
      message += `📝 *Message Details*\n`;
      message += `Subject: ${formData.subject}\n`;
      message += `Message: ${formData.message}\n\n`;
      
      message += `📱 *SMS Consent*\n`;
      message += `Agreed to receive SMS: ${formData.smsConsent ? 'Yes' : 'No'}\n\n`;
      
      message += `🕒 Submitted: ${new Date().toLocaleString()}`;
      
      const encodedMessage = encodeURIComponent(message);
      const whatsappNumber = '17182004140';
      const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
      
      window.open(whatsappURL, '_blank');
      
      alert('✅ Email sent to ahmadyasin7786@gmail.com!\n\nOpening WhatsApp. Please send the pre-filled message.');
      
      setSubmitStatus('success');
      
      // Reset form after successful submission
      setTimeout(() => {
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
          smsConsent: false
        });
        setSubmitStatus(null);
      }, 3000);
      
    } catch (error) {
      console.error('Submission failed:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="font-sans">
      <ContactHero />
      
      {/* Contact Content Section */}
      <section className="w-full py-8 sm:py-12 lg:py-16 px-4 sm:px-6 md:px-8 bg-white">
        <div className="max-w-[1200px] mx-auto">
          {/* Main Heading */}
          <h2 className="font-bold text-black mb-12 text-center">
            GET IN TOUCH
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Column - Contact Form */}
            <div>
              <form onSubmit={handleSubmit}>
                {/* Form Grid with 2 columns for first two fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  {/* First Name */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      First Name
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="First Name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  {/* Last Name */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Last Name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                {/* Phone Number */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                {/* Divider Line */}
                <div className="border-t border-gray-300 my-8"></div>

                {/* Subject */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                {/* Message */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your Message"
                    rows="5"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                  ></textarea>
                </div>

                {/* SMS Consent */}
                <div className="flex items-start space-x-3 mb-8">
                  <input
                    type="checkbox"
                    id="sms-consent"
                    name="smsConsent"
                    checked={formData.smsConsent}
                    onChange={handleChange}
                    className="mt-1 h-5 w-5 text-blue-600 rounded"
                  />
                  <label htmlFor="sms-consent" className="text-sm text-gray-700">
                    By checking this box, I agree to receive SMS messages from Majestic Voyague Limo using the phone number provided above. The SMS frequency may vary. Data rates may apply. 
                  </label>
                </div>

                {/* Submit Status Messages */}
                {submitStatus === 'success' && (
                  <div className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    ✅ Email sent successfully! Opening WhatsApp to send your message. Please send the pre-filled message to complete your inquiry.
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    Sorry, there was an error. Please try again or call us directly at +1 (718) 200 4140.
                  </div>
                )}

                {/* Submit Button */}
                <button 
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-black text-white px-6 py-3 sm:py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors text-base sm:text-lg min-h-[44px] disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'SENDING...' : 'SUBMIT'}
                </button>
              </form>
              
            </div>

            {/* Right Column - Map and Location */}
            <div>
              <h2 className="font-bold text-center text-gray-900 mb-6">
                OUR LOCATION
              </h2>
              
              

              {/* Divider */}
              <div className="border-t border-gray-300 my-8"></div>

              {/* Google Map Embed */}
              <div className="mb-8">
                <div className="w-full h-[400px] bg-gray-200 rounded-lg overflow-hidden">
                  {/* Google Maps iframe */}
                  <iframe 
                    src="https://www.google.com/maps?q=169+Munro+Blvd,+Valley+Stream,+NY+11581&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Majestic Voyage USA Location - 169 Munro Blvd, Valley Stream, NY 11581"
                    className="w-full h-full"
                  ></iframe>
                </div>
              </div>

              

              {/* Contact Info - Exactly like picture */}
              <div className="mt-12 pt-4 border-t border-gray-300">
                <div className="space-y-3">
                  <h3 className="font-semibold mb-3">
                  Contact Information
                 </h3>
                  <p className="text-gray-900 font-medium">
                    <a href="tel:+17182004140" className="hover:text-logo-green transition-colors">
                      +1 (718) 200 4140
                    </a>
                  </p>
                  <p className="text-gray-900 font-medium">
                    <a href="tel:+12124332303" className="hover:text-logo-green transition-colors">
                      +1 (212) 433 2303
                    </a>
                  </p>
                  <p className="text-gray-900 font-medium">
                    <a href="mailto:info@majesticvoyageusa.com" className="hover:text-logo-green transition-colors">
                      info@majesticvoyageusa.com
                    </a>
                  </p>
                  <p className="text-gray-900 font-medium">
                    169 Munro Boulevard Valley Stream NY 11581
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQ />
      <Footer />
    </div>
  );
};

export default ContactUs;









